import React from "react";
import { useNavigate } from "react-router-dom";
import {
     MainLeftTitle,
     CreateButton,
} from "../../../_uiComponents/WrapperComponents";
import CxWinnersGrid from "./views/CxWinnersGrid";

export default function CxWinnersWrapper() {
     const navigate = useNavigate();

     return (
          <>
               <MainLeftTitle title="CX Always in Touch Winners">
                    <CreateButton
                         name="Add Winners"
                         onClick={() =>
                              navigate("/app/cx-always-in-touch-winners/add")
                         }
                    />
               </MainLeftTitle>

               <CxWinnersGrid />
          </>
     );
}
